module.exports = __webpack_public_path__ + "img/user.e016c19c.png";